import { render } from "./ModalPriceSchedules.vue?vue&type=template&id=6c460f2a&scoped=true"
import script from "./ModalPriceSchedules.vue?vue&type=script&lang=js"
export * from "./ModalPriceSchedules.vue?vue&type=script&lang=js"

import "./ModalPriceSchedules.vue?vue&type=style&index=0&id=6c460f2a&scoped=true&lang=css"

import exportComponent from "/var/www/html/minty.crm.frontend.merchant/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c460f2a"]])

export default __exports__